<template>
  <v-card flat class="mx-auto">
    <v-list>
      <v-list-item :class="$vuetify.breakpoint.smAndDown ? 'px-0' : ''">
        <v-list-item-avatar
          size="64"
          v-if="profile.media && profile.media.length && profile.media[0].url"
        >
          <img :src="profile.media[0].url" />
        </v-list-item-avatar>
        <v-list-item-avatar size="64" class="doctor-avatar-img" v-else>{{
          profile | initial
        }}</v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="doctor-name"
            >{{ profile.firstName }} {{ profile.lastName }}</v-list-item-title
          >
          <v-list-item-subtitle v-if="profile.roles" class="doctor-role">
            {{ profile.roles.name }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list-item
      v-if="profile.bio !== '' && $vuetify.breakpoint.mdAndUp"
      class="py-4"
    >
      <v-card outlined v-if="profile.bio">
        <v-card-title class="bio-title">About</v-card-title>
        <v-card-text class="bio-text text-justify">
          {{ profile.bio }}
        </v-card-text>
      </v-card>
       <v-card flat v-if="!profile.bio">
        <v-card-title class="bio-title px-0">About</v-card-title>
        <v-card-text class="bio-text text-justify pa-0">
          No information provided.
        </v-card-text>
      </v-card>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "DoctorDetails",
  props: {
    profile: Object
  }
};
</script>
<style>
.speciality-list li span {
  position: relative;
  left: -7px;
  color: rgb(52, 68, 82);
}
.speciality-list li {
  color: #fcae00;
}
.doctor-title {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 24px;
  color: #27445b;
}
.doctor-name {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 18px;
  color: #27445b;
}
.doctor-role {
  font-family: "Now Alt";
  font-weight: 300;
  font-size: 16px;
  color: #27445b;
}
.bio-title {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  color: #27445b;
}
.bio-text {
  font-family: "Now Alt";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #27445b;
}
.no-data-text {
  text-align: center !important;
  font-size: 16px;
}
.doctor-avatar-img {
  font-size: 36px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  color: #000000 !important;
  border: 1px solid #d6e0ef !important;
}
</style>
